import { FunctionComponent, JSX } from 'react'
import Link from '../../../_custom/Link/Link'
import { Role } from '@/types/Role'
import styles from './buttonLink.module.scss'
import { Badge } from '@mui/material'

interface ButtonLinkProps {
    href: string
    locationActive: boolean
    role: Role
    icon: JSX.Element
    text: string
    badge?: string | number
    isMobile?: boolean
}

const ButtonLink: FunctionComponent<ButtonLinkProps> = ({
    href,
    locationActive,
    role,
    icon,
    text,
    badge,
    isMobile = false
}: ButtonLinkProps) => {
    return (
        <Link
            href={href}
            target={'_self'}
            className={`${styles.Link} ${role === Role.parent ? styles.LinkParent : styles.LinkDaycare}
				 ${
                     isMobile
                         ? locationActive
                             ? role === Role.parent
                                 ? styles.ActiveLinkMobileParent
                                 : styles.ActiveLinkMobileDaycare
                             : ''
                         : locationActive
                           ? role === Role.parent
                               ? styles.ActiveLinkWebParent
                               : styles.ActiveLinkWebDaycare
                           : ''
                 }
			`}
        >
            {badge ? (
                <Badge badgeContent={badge} className={role === Role.parent ? styles.BadgeParent : styles.BadgeDaycare}>
                    <div className={styles.IconAndText}>
                        {icon}
                        <p className={isMobile ? styles.TextMobile : styles.TextWeb}>{text}</p>
                    </div>
                </Badge>
            ) : (
                <div className={styles.IconAndText}>
                    {icon}
                    <p className={isMobile ? styles.TextMobile : styles.TextWeb}>{text}</p>
                </div>
            )}
        </Link>
    )
}

export default ButtonLink
